import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'stage-site-branch' as const;

const argumentZod = z.object({
  siteBranchId: z
    .string()
    .min(1)
    .describe(
      'Site-branch id from list-site-branches. Stages that live site-scope branch (Releases) to its staging domain.'
    ),
});

export const stageSiteBranchManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Stage site branch',
  family: 'site-branches',
  llmTool: {
    name: toolName,
    description:
      'Stages (publishes to staging) a live site-scope branch (Releases) for the current site. Returns { taskId, stagingDomain } — poll the task with get-site-branch-task for completion; stagingDomain is the preview host once the task succeeds. Distinct from publish-site (production) and from page-branch publish-branch.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.SITE_BRANCHES,
  requiredScopes: ['branches:publish'],
  permission: [
    {
      resource: 'SiteBranch',
      action: 'publish',
      resolveResources: (args) => [{type: 'SiteBranch', id: args.siteBranchId}],
    },
  ],
  // Holds the site's single pending site_publish slot while it runs — can
  // collide with a human's production publish. Same confirm bar as publish-site.
  confirmBeforeExecuting: true,
  isConcurrencySafe: () => false,
  isReadOnly: () => false,
});

export type StageSiteBranchArgumentType = z.infer<typeof argumentZod>;
